import React, { useState } from "react";

function parseValue(value) {
  const raw = String(value ?? "").replace(/[$,\s]/g, "");
  if (!raw) return 0;
  const parsed = Number(raw);
  return Number.isFinite(parsed) ? parsed : 0;
}

function formatValue(value) {
  return `$${Number(value || 0).toLocaleString("en-US", {
    minimumFractionDigits: Number(value || 0) % 1 ? 2 : 0,
    maximumFractionDigits: 2,
  })}`;
}

export default function CurrencyInput({ value, onChange, ...props }) {
  const [focused, setFocused] = useState(false);
  const [draft, setDraft] = useState("");
  return (
    <input
      {...props}
      type="text"
      inputMode="decimal"
      value={focused ? draft : formatValue(value)}
      onFocus={(event) => {
        setDraft(String(value ?? ""));
        setFocused(true);
        props.onFocus?.(event);
      }}
      onBlur={(event) => {
        setFocused(false);
        setDraft("");
        props.onBlur?.(event);
      }}
      onChange={(event) => {
        setDraft(event.target.value);
        onChange(parseValue(event.target.value));
      }}
    />
  );
}
